{
  "clear": "مسح",
  "invalid": "(غير صالح)",
  "loading": "جارٍ التحميل...",
  "noResults": "لا توجد نتائج",
  "valid": "(صالح)"
}
